import React, { forwardRef } from 'react';

import { DIVIDER_ROLE } from './EvDivider.constants';
import { EvDividerProps } from './EvDivider.types';

import styles from './EvDivider.module.scss';

export const EvDivider = forwardRef<HTMLElement, EvDividerProps>((props, ref) => {
	const {
		as: Component = 'hr',
		orientation = 'horizontal',
		variant = 'fullWidth',
		flexItem = false,
		...rest
	} = props;

	const classNames = [
		styles.divider,
		styles[`orientation-${orientation}`],
		styles[`variant-${variant}`],
		flexItem && styles.flexItem
	]
		.filter(Boolean)
		.join(' ');

	const isNonSemanticElement = Component !== 'hr';

	const ariaProps = isNonSemanticElement
		? { role: DIVIDER_ROLE, 'aria-orientation': orientation }
		: {};

	const componentProps = {
		ref,
		className: classNames,
		...ariaProps,
		...rest
	};

	return <Component {...componentProps} />;
});

EvDivider.displayName = 'EvDivider';
